"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHublVideoUploadSuccessAlert = exports.getFileUploadSuccessAlert = exports.getReadOnlyPermissionMessaging = exports.getReadOnlyPermissionCopy = exports.getSuccessNotification = exports.getCanvaDownloadFailedNotification = exports.getFetchHubUsersFailedNotification = exports.getFetchSignedURLFailedNotification = exports.getThumbnailFolderNetworkRequestFailedNotification = exports.getVideoThumbnailNetworkRequestFailedNotification = exports.getAnimatedGifVideoThumbnailFailureNotification = void 0;

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _ExternalLinks = require("../constants/ExternalLinks");

var getAnimatedGifVideoThumbnailFailureNotification = function getAnimatedGifVideoThumbnailFailureNotification() {
  return {
    type: 'danger',
    titleText: _I18n.default.text('FileManagerCore.notifications.animatedGifVideoThumbnail.error.title'),
    message: _I18n.default.text('FileManagerCore.notifications.animatedGifVideoThumbnail.error.message')
  };
};

exports.getAnimatedGifVideoThumbnailFailureNotification = getAnimatedGifVideoThumbnailFailureNotification;

var getVideoThumbnailNetworkRequestFailedNotification = function getVideoThumbnailNetworkRequestFailedNotification() {
  return {
    type: 'danger',
    titleText: _I18n.default.text('FileManagerCore.notifications.videoThumbnail.error.title'),
    message: _I18n.default.text('FileManagerCore.notifications.videoThumbnail.error.message')
  };
};

exports.getVideoThumbnailNetworkRequestFailedNotification = getVideoThumbnailNetworkRequestFailedNotification;

var getThumbnailFolderNetworkRequestFailedNotification = function getThumbnailFolderNetworkRequestFailedNotification() {
  return {
    type: 'danger',
    titleText: _I18n.default.text('FileManagerCore.notifications.videoThumbnailFolder.error.title'),
    message: _I18n.default.text('FileManagerCore.notifications.videoThumbnailFolder.error.message')
  };
};

exports.getThumbnailFolderNetworkRequestFailedNotification = getThumbnailFolderNetworkRequestFailedNotification;

var getFetchSignedURLFailedNotification = function getFetchSignedURLFailedNotification() {
  return {
    type: 'danger',
    titleText: _I18n.default.text('FileManagerCore.notifications.fetchSignedURL.error.title'),
    message: _I18n.default.text('FileManagerCore.notifications.fetchSignedURL.error.message')
  };
};

exports.getFetchSignedURLFailedNotification = getFetchSignedURLFailedNotification;

var getFetchHubUsersFailedNotification = function getFetchHubUsersFailedNotification() {
  return {
    type: 'danger',
    titleText: _I18n.default.text('FileManagerCore.notifications.fetchHubUsers.error.title'),
    message: _I18n.default.text('FileManagerCore.notifications.fetchHubUsers.error.message')
  };
};

exports.getFetchHubUsersFailedNotification = getFetchHubUsersFailedNotification;

var getCanvaDownloadFailedNotification = function getCanvaDownloadFailedNotification() {
  return {
    type: 'danger',
    titleText: _I18n.default.text('FileManagerCore.notifications.upload.error.title'),
    message: _I18n.default.text('FileManagerCore.notifications.upload.error.message')
  };
};

exports.getCanvaDownloadFailedNotification = getCanvaDownloadFailedNotification;

var getSuccessNotification = function getSuccessNotification(notificationKey) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'success' : _ref$type;

  return {
    type: type,
    titleText: _I18n.default.text("FileManagerCore.notifications." + notificationKey + "." + type + ".title"),
    message: _I18n.default.text("FileManagerCore.notifications." + notificationKey + "." + type + ".message")
  };
};

exports.getSuccessNotification = getSuccessNotification;

var getReadOnlyReasonKey = function getReadOnlyReasonKey(reason) {
  return "FileManagerCore.permissions.readOnlyReason." + reason;
};

var getReadOnlyPermissionCopy = function getReadOnlyPermissionCopy(readOnlyReason) {
  return _I18n.default.lookup(getReadOnlyReasonKey(readOnlyReason));
};

exports.getReadOnlyPermissionCopy = getReadOnlyPermissionCopy;

var getReadOnlyPermissionMessaging = function getReadOnlyPermissionMessaging(readOnlyReason) {
  var copyInfo = getReadOnlyPermissionCopy(readOnlyReason);

  if (!copyInfo) {
    return copyInfo;
  }

  var messaging = {};
  Object.keys(copyInfo).forEach(function (key) {
    messaging[key] = _react.default.createElement(_FormattedMessage.default, {
      message: getReadOnlyReasonKey(readOnlyReason) + "." + key
    });
  });
  return messaging;
};

exports.getReadOnlyPermissionMessaging = getReadOnlyPermissionMessaging;

var getFileUploadSuccessAlert = function getFileUploadSuccessAlert(fileVisibility, count, onClick) {
  return {
    type: 'success',
    titleText: _react.default.createElement(_FormattedMessage.default, {
      message: "FileManagerCore.alerts.upload.success.title",
      options: {
        visibility: _I18n.default.text("FileManagerCore.alerts.fileAccess." + fileVisibility),
        count: count
      }
    }),
    message: _react.default.createElement(_FormattedJSXMessage.default, {
      message: "FileManagerCore.alerts.upload.success.text_jsx",
      elements: {
        UILink: _UILink.default
      },
      options: {
        fileVisibilityLink: _ExternalLinks.FILE_VISIBILITY_HELP_LINK,
        onClick: onClick
      }
    })
  };
};

exports.getFileUploadSuccessAlert = getFileUploadSuccessAlert;

var getHublVideoUploadSuccessAlert = function getHublVideoUploadSuccessAlert(count) {
  return {
    type: 'success',
    titleText: _react.default.createElement(_FormattedMessage.default, {
      message: "FileManagerCore.alerts.upload.success.hublVideo.title",
      options: {
        count: count
      }
    }),
    message: _react.default.createElement(_FormattedMessage.default, {
      message: "FileManagerCore.alerts.upload.success.hublVideo.message"
    })
  };
};

exports.getHublVideoUploadSuccessAlert = getHublVideoUploadSuccessAlert;